module.exports = __webpack_public_path__ + "fonts/Poppins-ThinItalic.272bb704.ttf";